import { get } from '@classic/Foundation/Services/ApiService'
import type {
  StructuredSearchResult,
  StructuredSearchAggregations,
  StructuredSearchStatistics,
} from '@core/Areas/StructuredSearch/types'

export async function getStructuredSearchResults(
  /** @requires prefix `?` if not empty */
  queryParams: string
) {
  return get<{
    hitCount: number
    results: StructuredSearchResult[]
    statistics: StructuredSearchStatistics
    aggregations: StructuredSearchAggregations | null
  }>({ url: `/api/search/structured${queryParams}` })
}
